import { Component } from '@angular/core';
import { NewPasswordFormComponent } from "../../components/form/new-password-form/new-password-form.component";

@Component({
  selector: 'app-newpassword',
  standalone: true,
  imports: [NewPasswordFormComponent],
  templateUrl: './newpassword.component.html',
  styleUrl: './newpassword.component.css'
})
export class NewpasswordComponent {

}
